export const allowedUserIdsForProd = [
    "40fe645e-af8f-4190-b559-ef364e756b97",
    "0199854c-cfe6-4927-a3cf-ed40876fe5df",
    "a06491a7-180a-44d3-8b2d-94dff62fa72a",
];

export const allowedUserIdsForDev = [
    "9f7023ff-9866-4bf5-a40b-a46ef2fcdb87",
    "cde71064-1d3d-4c7c-bd8c-d16c86e05dab",
];
